import * as S from './styled';
import * as SS from '../../styled';

export const RatingsBlock = ({ t }) => (
  <S.RatingsContent>
    <S.RatingScore>4.6</S.RatingScore>
    <S.StarRatingColumn>
      <picture>
        <source
          media="(prefers-color-scheme: dark)"
          srcSet="./assets/storeV2/stars-dark.svg"
        />
        <SS.Image
          src="./assets/storeV2/stars.svg"
          alt="4.6 stars"
          $width={147}
          $height={23}
        />
      </picture>
      <S.RatingsCount>499k {t('ratings')}</S.RatingsCount>
    </S.StarRatingColumn>
  </S.RatingsContent>
);
